import styled from 'styled-components';

export const SignInContainer = styled.div`
  width: 380px;
  display: flex;
  flex-direction: column;

  h2 {
    margin: 10px 0;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;

